import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49b2b958"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar-wrapper" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "content" }
const _hoisted_4 = ["src"]

import { onMounted, ref } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const activeIndex = ref(0);

  const tabs = [
    { title: '전 세계 현황', url: require('../images/tab-2-section-2-1.jpg') },
    { title: '우리나라 현황', url: require('../images/tab-2-section-2-2.jpg') },
  ];

  onMounted(() => {});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (item, index) => {
        return _createElementVNode("div", {
          key: index,
          class: _normalizeClass(["item", { active: activeIndex.value === index }]),
          onClick: ($event: any) => (activeIndex.value = index)
        }, _toDisplayString(item.title), 11, _hoisted_2)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (item, index) => {
        return _withDirectives(_createElementVNode("img", {
          key: index,
          src: item.url,
          class: "image"
        }, null, 8, _hoisted_4), [
          [_vShow, activeIndex.value === index]
        ])
      }), 64))
    ])
  ]))
}
}

})